import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
import { getViewSingleOrMultipleInvoicesCTA } from "./shared";
export var WhereToFindInvoicesL3IA = function WhereToFindInvoicesL3IA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return ACCESS_INVOICES(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getDescription(context, strictLocalize);
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewSingleOrMulti;
        return (_getViewSingleOrMulti = getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)) === null || _getViewSingleOrMulti === void 0 ? void 0 : _getViewSingleOrMulti.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewSingleOrMulti2, _getViewSingleOrMulti3;
        return (_getViewSingleOrMulti2 = getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)) === null || _getViewSingleOrMulti2 === void 0 ? void 0 : (_getViewSingleOrMulti3 = _getViewSingleOrMulti2.getLink) === null || _getViewSingleOrMulti3 === void 0 ? void 0 : _getViewSingleOrMulti3.call(_getViewSingleOrMulti2, context.brandOrder);
      }
    }
  };
};
var getDescription = function getDescription(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return [ACCESS_ANY_ORDER_INVOICE_USING_BUTTON(strictLocalize)];
  }
  return [ACCESS_ORDER_INVOICE_USING_BUTTON(strictLocalize)];
};
var ACCESS_INVOICES = function ACCESS_INVOICES(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "BPJCz1",
      defaultMessage: [{
        "type": 0,
        "value": "Comment trouver une facture"
      }]
    });
  }
  return strictLocalize({
    id: "pHHuVh",
    defaultMessage: [{
      "type": 0,
      "value": "Accéder aux factures"
    }]
  });
};
var ACCESS_ANY_ORDER_INVOICE_USING_BUTTON = function ACCESS_ANY_ORDER_INVOICE_USING_BUTTON(strictLocalize) {
  return strictLocalize({
    id: "KQtIO/",
    defaultMessage: [{
      "type": 0,
      "value": "Cliquez sur le bouton ci-dessous pour voir la facture de la commande de votre choix."
    }]
  });
};
var ACCESS_ORDER_INVOICE_USING_BUTTON = function ACCESS_ORDER_INVOICE_USING_BUTTON(strictLocalize) {
  return strictLocalize({
    id: "MHKq1o",
    defaultMessage: [{
      "type": 0,
      "value": "Cliquez sur le bouton ci-dessous pour voir la facture de la commande que vous avez sélectionnée."
    }]
  });
};